// @flow
import React, { useEffect } from 'react';
import AppRouter from './routes/AppRouter';
import TawkTo from "tawkto-react";

import NotificationBuild from './components/NotificationBuild';

// Themes
import './assets/scss/DefaultTheme.scss';
import ScriptTag from './components/ScriptTag';

function App() {
    const checkGA = (timeout) => {
        if (window.google_tag_manager !== undefined) {
            return;
        } else {
            if (timeout && TawkTo) {
                const pluginModeUrl = new URLSearchParams(window.location.search).get('plugin');
                if (URL.canParse(pluginModeUrl)) {
                    // If the URL is valid, we don't attach Tawk.to
                    return;
                }
                new TawkTo(import.meta.env.VITE_TAWKTO_PROPERTY_ID, import.meta.env.VITE_TAWKTO_KEY);
            } else {
                setTimeout(() => checkGA(true), 4000);
            }
        }
    }

    useEffect(() => {
        checkGA(false);
    }, []);

    return (
        <>
            {import.meta.env.VITE_ENTRI_AUTO_DNS === '1' && <ScriptTag type="text/javascript" id="entri-js" src="https://cdn.goentri.com/entri.js" async />}
            <NotificationBuild />
            <AppRouter />
        </>
    )
}

export default App;
